import { render, staticRenderFns } from "./smw.vue?vue&type=template&id=6d3baf98&scoped=true"
import script from "./smw.vue?vue&type=script&lang=js"
export * from "./smw.vue?vue&type=script&lang=js"
import style0 from "./smw.vue?vue&type=style&index=0&id=6d3baf98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3baf98",
  null
  
)

export default component.exports